// import React from "react";
import { FaExclamationTriangle, FaTimes } from "react-icons/fa";

const AutoLogoutMeetingModal = ({
  isOpen,
  onClose,
  onConfirm,
  onKeepSessionOpen,
  setKeepSessionOpenDuration,
  title = "This image is in use",
  description = "Deleting it will affect the elements below:",
}) => {
  if (!isOpen) return null;

  const handleChange = (e) => {
    setKeepSessionOpenDuration(e.target.value);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/60 backdrop-blur-sm p-4">
      <div className="
        w-full max-w-[508px] 
        rounded-[20px] 
        border border-[#9B9B9B] 
        bg-[#060621] 
        flex flex-col gap-2 
        p-8 
        relative
      ">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 hover:bg-gray-700/50 rounded-full transition-colors"
        >
          <FaTimes className="w-5 h-5 text-gray-400 hover:text-white" />
        </button>

        <div className="flex flex-col w-full gap-6">

          {/* Icon + Title + Description */}
          <div className="flex flex-col items-center gap-4">
            <img
              src="/time_icon.png"
              alt="Warning Icon"
              className="w-[28.18px] h-[27.96px]"
            />

            <h2 className="text-white text-center text-base leading-6 px-4 sm:px-8">
              {title}
            </h2>

            <p className="text-white text-center text-base leading-6 px-4 sm:px-8">
              {description}
            </p>
          </div>

          {/* Radio Buttons */}
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            <label className="inline-flex items-center">
              <input
                type="radio"
                className="form-radio text-red-600"
                name="sessionDuration"
                value="10"
                defaultChecked
                onChange={handleChange}
              />
              <span className="ml-2 font-normal text-base leading-6 text-white">
                10 Minutes
              </span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                className="form-radio text-red-600"
                name="sessionDuration"
                value="30"
                onChange={handleChange}
              />
              <span className="ml-2 font-normal text-base leading-6 text-white">
                30 Minutes
              </span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                className="form-radio text-red-600"
                name="sessionDuration"
                value="60"
                onChange={handleChange}
              />
              <span className="ml-2 font-normal text-base leading-6 text-white">
                1 Hour
              </span>
            </label>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 mt-4">
            <button
              onClick={onConfirm}
              className="w-full sm:w-auto rounded-lg border border-[#FF0013] text-[#FF0013] font-montserrat font-medium text-[10px] leading-[14px] tracking-[0.25px] py-2 px-3 transition-colors"
            >
              End Session Now
            </button>

            <button
              onClick={onKeepSessionOpen}
              className="w-full sm:w-auto rounded-lg bg-[#7700FF] text-white font-montserrat font-medium text-[10px] leading-[14px] tracking-[0.25px] py-2 px-3 transition-colors"
            >
              Keep Session Open
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutoLogoutMeetingModal;
